export const environment = {
  production: false,
  version: '1.0.0',
  buildDate: '05-04-2025 02:45:07 AEDT',
  buildEnv: 'development',
};
